export default {
  requiredMark: '(*)'
}

export const en = {
  requiredMark: '(*)'
}

export const ca = {
  requiredMark: '(*)'
}
